import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import renderSelectField from "../../../../../../shared/components/form/Select";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    credits: "",
    source: "",
    order_id: "",
    reference: "",
    reason: "",
    other_reason: "",
    refund_issued: "",
    use_case: "",
    other_usage: "",
    comment: "",
  };

  componentDidMount() {
    this.props.handleForm(this.state);
  }

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  formConnectionHandler = (event) => {
    this.setState({ source: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formUsageConnectionHandler = (event) => {
    this.setState({ use_case: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formReasonConnectionHandler = (event) => {
    this.setState({ reason: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formRefundIssuedConnectionHandler = (event) => {
    this.setState({ refund_issued: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>
        <form autoComplete="off" className="form form--horizontal" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <span className="form__form-group-label">Credits&nbsp;*</span>
            <div className="form__form-group-field">
              <Field
                name="credits"
                component="input"
                type="number"
                placeholder="Credits"
                onKeyUp={this.formChangeHandler}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Source &nbsp;*</span>
            <div className="form__form-group-field">
              <Field
                name="source"
                component={renderSelectField}
                options={[
                  { value: "chargebee", label: "ChargeBee" },
                  { value: "fastspring", label: "FastSpring" },
                  { value: "paypal", label: "PayPal" },
                  { value: "bitcoin", label: "Crypto" },
                ]}
                onChange={this.formConnectionHandler}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">Order Id</span>
            <div className="form__form-group-field">
              <Field
                name="order_id"
                component="input"
                type="text"
                placeholder="Order Id"
                onKeyUp={this.formChangeHandler}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              Transaction Id&nbsp;*
            </span>
            <div className="form__form-group-field">
              <Field
                name="reference"
                component="input"
                type="text"
                placeholder="Transaction Id"
                onKeyUp={this.formChangeHandler}
              />
            </div>
          </div>
          {!this.props.add ? (
            <div className="form__form-group">
              <span className="form__form-group-label">Reason</span>
              <div className="form__form-group-field">
                <Field
                  name="reason"
                  component={renderSelectField}
                  options={[
                    { value: "Adjustment", label: "Adjustment" },
                    { value: "Dispute", label: "Dispute" },
                    { value: "Duplicate charge", label: "Duplicate charge" },
                    {
                      value: "Excess credit removal",
                      label: "Excess credit removal",
                    },
                    { value: "Fraud", label: "Fraud" },
                    { value: "Refund requested", label: "Refund requested" },
                    { value: "Testing", label: "Testing" },
                    { value: "Others", label: "Others" },
                  ]}
                  onChange={this.formReasonConnectionHandler}
                />
              </div>
            </div>
          ) : (
            ""
          )}

          {this.state.reason !== undefined && this.state.reason === "Others" ? (
            <div className="form__form-group">
              <span className="form__form-group-label">Other Reason</span>
              <div className="form__form-group-field">
                <Field
                  name="other_reason"
                  component="input"
                  type="text"
                  placeholder="Other reason"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
          ) : (
            ""
          )}
          {!this.props.add ? (
            <div className="form__form-group">
              <span className="form__form-group-label">Refund issued</span>
              <div className="form__form-group-field">
                <Field
                  name="refund_issued"
                  component={renderSelectField}
                  options={[
                    { value: "Yes", label: "Yes" },
                    { value: "No", label: "No" },
                  ]}
                  onChange={this.formRefundIssuedConnectionHandler}
                />
              </div>
            </div>
          ) : (
            ""
          )}
          {this.props.add ? (
            <div className="form__form-group">
              <span className="form__form-group-label">Usage</span>
              <div className="form__form-group-field">
                <Field
                  name="use_case"
                  component={renderSelectField}
                  options={this.props.useCases}
                  onChange={this.formUsageConnectionHandler}
                />
              </div>
            </div>
          ) : (
            ""
          )}
          {this.state.use_case !== undefined &&
          this.state.use_case === "Other" ? (
            <div className="form__form-group">
              <span className="form__form-group-label">Other Usage</span>
              <div className="form__form-group-field">
                <Field
                  name="other_usage"
                  component="input"
                  type="text"
                  placeholder="Other Usage"
                  onKeyUp={this.formChangeHandler}
                />
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="form__form-group">
            <span className="form__form-group-label">Comments</span>
            <div className="form__form-group-field">
              <Field
                name="comment"
                component="input"
                type="textarea"
                placeholder="Comment"
                onKeyUp={this.formChangeHandler}
              />
            </div>
          </div>
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "add_credit_form", // a unique identifier for this form
})(HorizontalForm);
